















































import Vue from "vue";
import Component from "vue-class-component";
import GeoUtils from "@/utils/geo_utils";
import { LPolyline, LLayerGroup, LPopup } from "vue2-leaflet";
import Vue2LeafletRotatedMarker from "vue2-leaflet-rotatedmarker";
import TagComponent from "../features/TagComponent.vue";
import { targets, maps } from "@/store";
import { LatLng } from "leaflet";


//import { LCircleMarker } from "vue2-leaflet";

const AisTargetProps = Vue.extend({
  props: {
    coords: {
      type: Object as () => LatLng,
    },
    sog: Number,
    cog: Number,
    hdg: {
      type: Number,
      default: 511,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    info: Object,
    icon: Object,
  },
});

@Component({
  components: {
    LPolyline,
    LLayerGroup,
    LPopup,
    "v-rotated-marker": Vue2LeafletRotatedMarker,
    TagComponent,
  },
})
export default class AisTarget extends AisTargetProps {
  //computed

  get predictionTime() {
    return targets.getters.predictionTime;
  }
  get targetsTagsEnabled() {
    return targets.getters.targetsTagsEnabled;
  }
  get measurementActivated() {
    return maps.getters.measurementActivated;
  }
  get targetTagsEnabledByZoom() {
    return maps.getters.targetTagsEnabledByZoom;
  }


  get polyCoords() {
    const vectorEndPoint = GeoUtils.endPointCalculator(
      this.coords,
      this.sog,
      this.cog,
      this.predictionTime
    );
    return [this.coords, vectorEndPoint];
  }
  get rotationHandler() {
    return this.hdg < 361 ? this.hdg : this.cog;
  }
  get speedValidator() {
    return !(this.sog > 102 && !this.info.altitude) && this.sog > 0.5;
  }
  get showTag() {
    return (
      this.selected || this.targetsTagsEnabled || this.targetTagsEnabledByZoom
    );
  }

  get isStale(): boolean {
  if (!this.info?.timestamp) return false;

  const now = new Date().getTime();
  const lastUpdate = new Date(this.info.timestamp).getTime();

  const diffMinutes = (now - lastUpdate) / 1000 / 60;
  return diffMinutes > 15;
  }

  //methods
  clickHandler(info: number) {
    this.$emit("clicked", info);
  }

  /*
  // colores
  get circleColor(): string {
    return this.info?.color || "#ff0000"; // fallback
  }
  */
}
